export default {
  data () {
    return {
      initialInnerWidth: window.innerWidth
    }
  },
  computed: {
    gridLg () {
      return this.initialInnerWidth >= 1200
    },
    gridMd () {
      return this.initialInnerWidth >= 992
    },
    gridSm () {
      return this.initialInnerWidth >= 768
    },
    gridXs () {
      return this.initialInnerWidth < 768
    }
  }
}
